//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data: () => ({
		links: [
			{
				name: 'Términos y condiciones',
				Link: 'https://findecursocolegio.com/condiciones',
			},
			{
				name: 'Politica de privacidad',
				Link: 'https://findecursocolegio.com/privacidad',
			},
			{
				name: 'Politica de cookies',
				Link: 'https://findecursocolegio.com/cookies',
			},
		],
	}),
};
